import { createContext, useState } from 'react';

interface UIContextValue {
  profileHighlighted: boolean;
  setProfileHighlighted: (highlighted: boolean) => void;
}

const UIContext = createContext<UIContextValue>({
  profileHighlighted: false,
  setProfileHighlighted: () => {},
});

const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [profileHighlighted, setProfileHighlighted] = useState(false);
  return (
    <UIContext.Provider
      value={{
        profileHighlighted,
        setProfileHighlighted,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export { UIContext, UIProvider };
